import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import profileMUHAMMEDHAK from './MUHAMMED HAK .png';
import profileADAMJNEID from './ADAM JUNAID.png';
import profileALAAALDABAK from './Alaa aldabak.png';
function Page27_b() {
const [ages, setAges] = useState({});

useEffect(() => {
const birthYears = {
MUHAMMEDHAK:2004,
ADAMJNEID:2008,
ALAAALDABAK:1983,
};
const currentYear = new Date().getFullYear();
const calculatedAges = Object.keys(birthYears).reduce((acc, person) => {
 acc[person] = currentYear - birthYears[person];
 return acc;
}, {});
setAges(calculatedAges);
}, []);
return (
<section>
<Container fluid className="home-section"  >
<h1 id="about-section" className="project-heading" data-aos="flip-down">
 Let me introduce you<strong className="purple"> about myself</strong>
</h1>
<Container className="home-content">
 <Row className="justify-content-center align-items-center" style={{ minHeight: '2vh' }}>
<Col md={5} className="home-header" data-aos="fade-right">
<div className="bg-yellow-500 rounded-full absolute w-12 h-12 z-0 -left-4 -top-3 animate-pulse"></div>
<h1 style={{ paddingBottom: 5 }} className="heading">
Hi I'M <strong className="main-name">MUHAMMED HAK </strong>
</h1>
<h1 className="heading-name">
My age now: {ages.MUHAMMEDHAK} years old
</h1>
<div className="bg-yellow-500 w-40 h-40 floating absolute rounded-lg z-10 -bottom-3 -right-3"></div>
</Col>
<Col md={3} className="d-flex justify-content-center align-items-center" data-aos="fade-left">
<div className="image-container" style={{ position: 'relative', display: 'inline-block' }}>
 <div style={{ background: "#23BDEE" }} className="floating w-24 h-24 absolute rounded-lg z-0 -top-3 -left-3"></div>
<img
src={profileMUHAMMEDHAK}
alt="home pic"
className="img-fluid"
style={{
boxShadow: '0 4px 10px rgba(0, 128, 0, 0.6)',
 width: '200px',
height: '200px',
objectFit: 'cover',
 borderRadius: '10px'
}}
/>
 <div className="bg-yellow-500 w-40 h-40 floating absolute rounded-lg z-10 -bottom-3 -right-3"></div>
</div>
</Col>
</Row>
</Container>
</Container>
<h1 id="story-section" className="project-heading" data-aos="flip-down">
This is my <strong className="purple">Story</strong>
</h1>
<Container fluid className="Story-section">
<Container>
<Row className="justify-content-center">
<Col md={4} className="text-left" data-aos="fade-right">
<p className="chinese-text">
姓名：穆罕默德·哈克
當我11歲時，在2015年，我和我的表弟阿布·巴克爾常在街上玩。
碰巧我們聽到身後有人用阿拉伯語說話。那是主麻先生和費薩爾先生還有娜蒂雅女士，他們說：“我們很快就會開一所學校，這將是一個成功的項目。
我們感到非常驚訝，我因為腳傷需要治療，已經兩年沒有上學了，而且我也不會說土耳其語，這兩者都是進入學校的障礙。所以，我們迅速跑去找他們，告訴他們：“我們也想上學。
他們來到我們家，收集了入學所需的信息，並向我們保證他們會通知我們開學日。
幾天後，滿納海學校 開學的消息傳來，我是最早報名入讀 滿納海學校 1 校的學生之一。在完成了六年的教育後，由於困難的生活條件以及父親當時的疾病，我不得不中途停止學業。
在那段時間里，我停止上學一年，轉而在男士理髮店工作。有一天，在我工作的時候，我錯過了主麻先生的一通電話。當我看到來電顯示時，我歡喜地笑了。我們聊了幾分鐘後，他問我是否想回到學校，並提供了一個等同於我工作收入的獎學金。我接受了並回到了學校。
主麻先生還和我談到了志工服務，我成為了媒體辦公室的一名學生志工。
在2023年2月6日土耳其發生毀滅性地震期間，我首次主動參與了在伊斯坦堡以外的大規模攝影志工服務。回來後，我驚訝地發現我的一張照片被用作台灣慈濟月刊的封面。我覺得透過這張照片，我能夠表達我對他們的感激之情。
今天，當我即將在20歲時從學校畢業，準備進入大學學習計算機工程時，我對我的第二個家庭深表感激，感謝他們始終如一的支持。
他們在我最脆弱的時刻站在我身邊，幫助我度過了艱難的時刻，使我能夠完成我的教育。
他們把我的生活從工廠工人轉變成了一個學習的人，有希望成為工程師，實現自己夢想，過上更好生活的人。
</p>
</Col>
<Col md={4} className="text-right" data-aos="fade-left">
<p className="arabic-text">
عندما كان عمري 11 عاما، في عام 2015 كنا نلعب في الشارع انا وابن اختي (ابو بكر). وفي الصدفة سمعنا شخص يتكلم من خلفنا باللغة العربية وقد كان الأستاذ جمعة ومعه أستاذ فيصل ويقول (قريبا سنفتتح المدرسة وسيكون مشروعا ناجحا). فاستغربنا لأننا قد كنا منقطعين عن التدريس لمدة عامين بسبب إصابتي في قدماي فكنت اذهاب للعلاج ولا اتحدث اللغة التركية ايضا، كانا عائقا في دخولي للمدرسة. فركضنا إليه مسرعين وقلنا له (نحن ايضا نريد أن ندرس)، فصعدوا الى منزلنا وأخذوا المعلومات اللازمة للتسجيل وقالوا سنخبركم بموعد افتتاح المدرسة. وبعد عدة ايام جاء خبر افتتاح مدرسة المناهل وكنت من اوائل الطلاب الذين قد سجلوا في مدرسة المناهل 1 وبعد استكمال التعليم ل ستة سنوات اضطررت على الانقطاع من التعليم بسبب الوضع المعيشي الصعب وبسبب مرض أبي في ووقتها. انقطعت عن لمدرسة لمدة عام وعملت خلالها في الحلاقة الرجالية. وفي يوم من الأيام اثناء عملي فاتتني مكالمة من أستاذ جمعة، ضحكت من الفرح عندما رأيت اسم المتصل وبعد أن تكلمنا لبضع دقائق قال لي ألا تريد أن تعود إلى المدرسة وسنوفر لك منحة بدل الراتب الذي تحصل عليه من العمل وبالفعل قبلت وعدت الى المدرسة وكلمني ايضا استاذ جمعة من أجل التطوع وأصبحت طالبا ومتطوعا في المكتب الإعلامي. وفي 6.2.2023 حصل زلزال تركيا المدمر وقد بادرت لأول مرة في عمل تطوعي كمصور الى خارج اسطنبول وعلى نطاق واسع وبعد عودتي فوجئت بأن صورة من تصويري وضعت غلاف لمجلة تايوان الفرع المركزي وشعرت أنني استطعت أن أرسل تشكري لهم وامتناني في هذه الصورة. وها أنا اليوم اقبلت على التخرج من المدرسة وعمري 20 عام ومقبل على الدخول للجامعة في قسم هندسة الحاسوب. إنني ممتن إلى عائلتي الثانية لأنهم لم يتركونني في اوقات ضعفي ووقفوا معي في الأوقات الصعاب وساعدوني في إكمال تعليمي ونقلوا حياتي من شخص سيصبح عاملا في إحدى المعامل الى شخص سيدرس الهندسة وسيصبح مهندسا ويحقق حلمه ويكمل حياته بشكل أفضل.
</p>
</Col>
</Row>
 </Container>
 </Container>
<Container fluid className="home-section"  >
<h1 id="about-section" className="project-heading" data-aos="flip-down">
 Let me introduce you<strong className="purple"> about myself</strong>
</h1>
<Container className="home-content">
 <Row className="justify-content-center align-items-center" style={{ minHeight: '2vh' }}>
<Col md={5} className="home-header" data-aos="fade-right">
<div className="bg-yellow-500 rounded-full absolute w-12 h-12 z-0 -left-4 -top-3 animate-pulse"></div>
<h1 style={{ paddingBottom: 5 }} className="heading">
Hi I'M <strong className="main-name">ADAM JNEID </strong>
</h1>
<h1 className="heading-name">
My age now: {ages.ADAMJNEID} years old
</h1>
<div className="bg-yellow-500 w-40 h-40 floating absolute rounded-lg z-10 -bottom-3 -right-3"></div>
</Col>
<Col md={3} className="d-flex justify-content-center align-items-center" data-aos="fade-left">
<div className="image-container" style={{ position: 'relative', display: 'inline-block' }}>
 <div style={{ background: "#23BDEE" }} className="floating w-24 h-24 absolute rounded-lg z-0 -top-3 -left-3"></div>
<img
src={profileADAMJNEID}
alt="home pic"
className="img-fluid"
style={{
boxShadow: '0 4px 10px rgba(0, 128, 0, 0.6)',
 width: '200px',
height: '200px',
objectFit: 'cover',
 borderRadius: '10px'
}}
/>
 <div className="bg-yellow-500 w-40 h-40 floating absolute rounded-lg z-10 -bottom-3 -right-3"></div>
</div>
</Col>
</Row>
</Container>
</Container>
<h1 id="story-section" className="project-heading" data-aos="flip-down">
This is my <strong className="purple">Story</strong>
</h1>
<Container fluid className="Story-section">
<Container>
<Row className="justify-content-center">
<Col md={4} className="text-left" data-aos="fade-right">
<p className="chinese-text">
我是亞當·朱奈德，目前就讀於滿納海學校。同時，我也在慈濟基金會極參與志工服務。
在2015年，我和家人居住在尤努斯·埃姆雷期間，我們得知蘇丹加濟有一所專門為敘利亞難民設立的學校。我的家人迅速為我在這所學校註冊。
當時，我對能夠就讀像滿納海學校這樣的學校感到非常高興。
最初開始在滿納海學校學習時，我發現這非常具有挑戰性。然而，隨著時間的推移和努力，我已經克服了那些挑戰，成長為一名成功和有成就的學生。
慈濟基金會的影響在我的生活中具有深遠的變革性。
慈濟基金會改變了我的生活。他們不僅幫助我就學，也支持了我的哥哥傑內德，他已經有4到5年沒有上學了。現在，他已經從大學畢業，成為一名工程師。
志工服務於慈濟基金會
在2018年，我了解了什麼是志工服務。那時候我還是個孩子，所以我經常跟著我的哥哥一起去做志工工作。
在人文真善美辦公室
因為我對攝影的興趣，我在志工余自成師兄的幫助下，參觀了慈濟基金會土耳其分部的媒體辦公室。多虧了他，我有機會作為攝影師與他們一起做志工服務。余先生還教我如何有效地拍照。今天，當我即將在20歲時從學校畢業，準備進入大學學習計算機工程時，我對學校深表感激，感謝他們始終如一的支持。
與慈濟滿納海學校團隊一起
每六個月，一組華語伴學計劃的志工們會來訪我們學校。作為一名志工，我通過翻譯協助他們，幫助他們與其他人交流。我的志工朋友們也加入我，提供翻譯支持，協助他們工作的進展。
</p>
</Col>
<Col md={4} className="text-right" data-aos="fade-left">
<p className="arabic-text">
أنا آدم جنيد، مسجل حاليًا في مدرسة مناهل. وفي الوقت نفسه، أشارك بشكل فعال كمتطوع داخل المؤسسة  
في عام 2015، أثناء إقامتي مع عائلتي في يونس إمري، تم إبلاغنا بوجود مدرسة تخدم اللاجئين السوريين في سلطان غازي. قامت عائلتي بتسجيلي على الفور في هذه المدرسة. في ذلك الوقت، كنت ممتلئًا بفرحة عميقة لاحتمال الالتحاق بمدرسة مثل مدرسة المناهل عندما بدأت الدراسة في المناهل لأول مرة، وجدت الأمر صعبًا للغاية. ومع ذلك، مع الوقت والجهد، تمكنت من التغلب على تلك التحديات وأصبحت طالب ناجح وبارع.  لقد كان تأثير Tzu Chi تحولًا عميقًا في حياتي.  لقد غيرت تسجي حياتي. لم يساعدوني في المدرسة فحسب؛ كما قاموا بدعم أخي الذي لم يذهب إلى المدرسة لمدة 4 إلى 5 سنوات. والآن تخرج من الجامعة كمهندس.   العمل التطوعي في تسجي في عام 2018، تعلمت معنى التطوع. في ذلك الوقت، كنت مجرد طفل، لذلك كنت أذهب مع أخي عندما كان يتطوع.  في المكتب الاعلامي   بسبب اهتمامي بالتصوير الفوتوغرافي، قمت بزيارة المكتب الإعلامي في Tzu Chi تركيا بمساعدة المتطوع السيد David Yu. وبفضله أتيحت لي الفرصة للتطوع كمصور معهم. علمني السيد ديفيد أيضًا كيفية التقاط الصور بفعالية.  مع فريق TC MENAHIL كل ستة أشهر، يقوم فريق من معلمي لغة الماندرين بزيارة مدرستنا. كمتطوع، أساعدهم من خلال الترجمة، ومساعدتهم على التواصل مع الآخرين. وينضم إلي زملائي الأصدقاء المتطوعين أيضًا في تقديم دعم الترجمة، مما يضمن التواصل الفعال أثناء زيارتهم
</p>
</Col>
</Row>
 </Container>
 </Container>
<Container fluid className="home-section"  >
<h1 id="about-section" className="project-heading" data-aos="flip-down">
 Let me introduce you<strong className="purple"> about myself</strong>
</h1>
<Container className="home-content">
 <Row className="justify-content-center align-items-center" style={{ minHeight: '2vh' }}>
<Col md={5} className="home-header" data-aos="fade-right">
<div className="bg-yellow-500 rounded-full absolute w-12 h-12 z-0 -left-4 -top-3 animate-pulse"></div>
<h1 style={{ paddingBottom: 5 }} className="heading">
Hi I'M <strong className="main-name"> ALAA AL DABAK </strong>
</h1>
<h1 className="heading-name">
My age now: {ages.ALAAALDABAK} years old
</h1>
<div className="bg-yellow-500 w-40 h-40 floating absolute rounded-lg z-10 -bottom-3 -right-3"></div>
</Col>
<Col md={3} className="d-flex justify-content-center align-items-center" data-aos="fade-left">
<div className="image-container" style={{ position: 'relative', display: 'inline-block' }}>
 <div style={{ background: "#23BDEE" }} className="floating w-24 h-24 absolute rounded-lg z-0 -top-3 -left-3"></div>
<img
src={profileALAAALDABAK}
alt="home pic"
className="img-fluid"
style={{
boxShadow: '0 4px 10px rgba(0, 128, 0, 0.6)',
 width: '200px',
height: '200px',
objectFit: 'cover',
 borderRadius: '10px'
}}
/>
 <div className="bg-yellow-500 w-40 h-40 floating absolute rounded-lg z-10 -bottom-3 -right-3"></div>
</div>
</Col>
</Row>
</Container>
</Container>
<h1 id="story-section" className="project-heading" data-aos="flip-down">
This is my <strong className="purple">Story</strong>
</h1>
<Container fluid className="Story-section">
<Container>
<Row className="justify-content-center">
<Col md={4} className="text-left" data-aos="fade-right">
<p className="chinese-text">
我來到土耳其是因為2016年的戰爭，我和我的父母來到這。
在到達土耳其三個月之後，我來到伊斯坦堡，到我哥哥家，他為我找到一份合適的工作。
我開始尋找一份適合我的工作，並在 Facebook 上找到一則關於蘇丹加濟地區 滿納海學校電腦教師職業的廣告。
當時，我對學校、基金會甚至這個地區一無所知。
我來到學校，向行政部門提交了我的檔案，經過考試和面試，我被學校錄取了。
當時我非常高興，這是我在滿納海學校和慈濟基金會開始志工服務的地方，我從上班的第一天起就開始做志工，為前來基金會尋求幫助的人提供協助當有被幫助的人說我很好運和幸福時，我感謝真主因為我真的感到幸福。
</p>
</Col>
<Col md={4} className="text-right" data-aos="fade-left">
<p className="arabic-text">
أتيت إلى تركيا بسبب الحرب عام ٢٠١٦ مع امي وابي.
بعد معاناة محاولة الوصول إلى تركيا لمدة ثلاث أشهر.
أتيت إلى اسطنبول إلى بيت اخي لغاية إيجاد عمل مناسب لي.
وبدأت بالبحث عن عمل يناسبني وقرأت اعلان في الفيسبوك عن مهنة معلم حاسوب في مدرسة المناهل بمنطقة السلطات غازي. حينها لم أكن أعرف اي شيء عن المدرسة ولا الجمعية ولا حتى المنطقة. 
أتيت إلى العنوان وقدمت ملفي للإدارة وبعد فحص ومقابلات تم قبولي في المدرسة. 
وكانت فرحتي عارمة حين ذلك. 
وهنا بدأت رحلتي التطوعية في مدرسة المناهل ومع مؤسسة تسجي الخيرية، وبدأت التطوع منذ الأيام الأولى لي في المدرسة في تقديم المساعدة للآخرين الذين يأتون إلى الجمعية طلبا للمساعدة.
 شعور السعادة والفرح يغمرني عندما يدعو لي أحد المحتاجين بالتوفيق والسعادة.
</p>
</Col>
</Row>
 </Container>
 </Container>
</section>
);
}
export default Page27_b;
